import React, { Component } from 'react';
import cookie from 'react-cookie';
import {
  REFERRER_COOKIE_NAME, REFERRER_COOKIE_MAX_AGE, REFERRAL_MONEY_DISCOUNT,
  REFERRAL_FEATURE_DISCOUNT
} from 'marketing/constants';

export default class Referral extends Component {
  componentDidMount() {
    const { params, router, showBanner } = this.props;

    cookie.save(
      REFERRER_COOKIE_NAME, params.referrer, { path: '/', maxAge: REFERRER_COOKIE_MAX_AGE }
    );

    showBanner(
      "Your discount code is ready to be applied!",
      `Your ${REFERRAL_MONEY_DISCOUNT} discount and ${REFERRAL_FEATURE_DISCOUNT} will be applied when you post your project.`,
      <i className="fa fa-tag" />
    );

    router.replace("/");
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./marketing/components/referral.jsx